import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Select } from "../../components";
import { AppConfig } from "../../config";

const { locales } = AppConfig;

const Languages: FC = () => {
  const { i18n } = useTranslation(AppConfig.translationFileNames.base);

  const onChange = (val: any) => {
    i18n.changeLanguage(val as string);
  };

  return (
    <div>
      <Select.Language value={i18n.language} onChange={onChange}>
        {locales.map(({ title, key, flag }) => (
          <Select.Option key={key + title} value={key} flag={flag}>
            {title}
          </Select.Option>
        ))}
      </Select.Language>
    </div>
  );
};

export default Languages;
